"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));

var _cogoToast = _interopRequireDefault(require("cogo-toast"));

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CodeBox = function CodeBox(_ref) {
  var children = _ref.children,
      canCopy = _ref.canCopy,
      className = _ref.className,
      otherProps = _ref.otherProps,
      copySuccessText = _ref.copySuccessText,
      copyTitle = _ref.copyTitle;

  var handleCopyClick = function handleCopyClick() {
    (0, _copyToClipboard.default)(children);

    _cogoToast.default.success(copySuccessText);
  };

  return /*#__PURE__*/_react.default.createElement(StyledCodeBox, _extends({
    canCopy: canCopy,
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement(Code, null, children), canCopy ? /*#__PURE__*/_react.default.createElement(CopyButton, {
    title: copyTitle,
    onClick: function onClick() {
      handleCopyClick();
    }
  }, /*#__PURE__*/_react.default.createElement(_Icons.IconClipBoard, {
    size: 25
  })) : null);
}; // 54


var StyledCodeBox = _styledComponents.default.div.withConfig({
  displayName: "StyledCodeBox"
})(["width:100%;max-width:100rem;padding:", ";background-color:white;border:1px solid #d5d5d5;border-radius:0.5rem;position:relative;"], function (_ref2) {
  var canCopy = _ref2.canCopy;
  return canCopy ? '1.6rem 5.4rem 1.6rem 1.6rem' : '1.6rem';
});

var Code = _styledComponents.default.code.withConfig({
  displayName: "Code"
})(["font-family:monospace;font-size:1.3rem;line-height:135%;letter-spacing:0.02em;color:#222;"]);

var CopyButton = _styledComponents.default.div.withConfig({
  displayName: "CopyButton"
})(["position:absolute;width:3.1rem;height:3.1rem;background-color:#f0f1f3;right:0.7rem;top:0.7rem;border-radius:0.5rem;display:flex;justify-content:center;align-items:center;cursor:pointer;transition:background-color 0.15s ease-in-out;> svg path{stroke:#8990a3;transition:stroke 0.15s ease-in-out;}&:hover{background-color:", ";> svg path{stroke:white;}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.brand.primary;
});

CodeBox.defaultProps = {
  canCopy: true,
  copySuccessText: 'Copied to clipboard.',
  copyTitle: 'Copy to clipboard'
};
CodeBox.propTypes = {
  /** Code to be displayed within the element. This is also what will be copied if copying is enabled. */
  children: _propTypes.node.isRequired,

  /** Set to false to remove the ability to copy with the button. */
  canCopy: _propTypes.bool,

  /** Text to be displayed in the toaster after copy. */
  copySuccessText: _propTypes.string,

  /** Extra classnames to pass to the element. */
  className: _propTypes.string,

  /** Title attribute for the clipboard button. */
  copyTitle: _propTypes.string,

  /** Extra props to pass to the element. */
  otherProps: _propTypes.object
};
var _default = CodeBox;
exports.default = _default;